import React from "react";
import "./PoliticaPrivacidad.css";

const PoliticaPrivacidad = () => {
  return (
    <div className="politica-container">
      <h1 className="politica-titulo">
        Aviso de Privacidad para Clientes, Proveedores, Empleados y Ex Empleados
      </h1>

      <div className="politica-texto">
        <p>
          Con fundamento en los artículos 15 y 16 de la Ley Federal de Protección de Datos Personales en
          Posesión de Particulares, hacemos de su conocimiento que <strong>SUPER COMPLETO SA DE CV</strong> con 
          domicilio fiscal PASEO DEL TECNOLOGICO 441 AMPLIACION LA ROSITA EN LA Ciudad de Torreón, Estado
          de Coahuila de Zaragoza, México, es responsable de recabar sus datos personales que utiliza y en la
          que en todo momento se busca y se buscará que el tratamiento de los mismos sea legítimo, controlado
          e informado, a efecto de asegurar la privacidad, confidencialidad, integridad y el derecho a la 
          autodeterminación informativa de sus datos.
        </p>
        <p>
        Le informamos que <strong>SUPER COMPLETO SA DE CV</strong> sólo obtiene los datos personales de sus  empleados, clientes
        y proveedores, ya sea porque se tiene una relación jurídica con dicho titular o bien, exista la posibilidad
        de tener dicha relación jurídica, de manera directa y personal, o bien, a través de los medios electrónicos,
        ópticos, sonoros, visuales o por cualquier otra tecnología u otras fuentes que estén permitidas por la ley,
        con la finalidad de acreditar la identificación del titular de dichos datos personales de conformidad con las
        leyes y disposiciones aplicables y con el único propósito de estar en posibilidades de celebrar el contrato que
        en su caso y por acuerdo mutuo se pretenda formalizar, para mantener y custodiar el expediente e información respectiva.
        </p>
        <p>
        Asimismo, se le informa que su información personal será utilizada para las siguientes finalidades: dar 
        cumplimiento a obligaciones contraídas con nuestros empleados, proveedores o clientes según sea el caso; 
        proveer la información, servicios o productos que ha solicitado y/o que vaya a solicitar en un futuro; comunicarle
        y/o notificarle sobre cambios relacionados con nuestra relación contractual; elaborar estudios o programas que son
        necesarios para postularlo como posible candidato de una relación contractual con nosotros o renovar contratos con
        ustedes; realizar evaluaciones periódicas de los servicios o productos contratados; evaluar la calidad de los servicios
        y/o productos contratados o por contratar; recabar información y cualquier acto tendiente con las necesidades de los titulares.
        </p>
        <p>
        Para las finalidades señaladas en el presente aviso de privacidad, le informamos que posiblemente en el pasado hayamos recabado
        y/o posiblemente en el futuro podamos recabar, sus datos personales de distintas formas: cuando usted nos los proporciona
        (proporcionó) directamente; cuando Usted visita (visitó) nuestro sitio de Internet y cuando obtenemos (obtuvimos) información
        a través de otras fuentes que están permitidas por la ley.
        </p>
        <p>
        Se le informa que recabamos sus datos personales de forma directa cuando usted mismo nos la proporciona por diversos medios,
        como cuando usted se postula como candidato de una relación contractual con nosotros o nos da información con objeto de que
        le prestemos un servicio o un bien. Asimismo le informamos que cuando visita nuestras instalaciones también recabamos datos
        personales. Podemos obtener información de usted de otras fuentes permitidas por la ley, tales como los directorios telefónicos
        o laborales. Los datos que obtenemos por cualquiera de estos medios pueden ser, entre otros:
        </p>

        <div className="politica-lista-columnas">
          <ul>
            <li>Nombre completo</li>
            <li>Edad</li>
            <li>Estado civil</li>
            <li>Sexo</li>
            <li>Teléfono fijo y/o celular</li>
          </ul>
          <ul>
            <li>Correo electrónico</li>
            <li>Firma autógrafa</li>
            <li>Dirección</li>
            <li>Nivel de escolaridad</li>
            <li>RFC y/o CURP</li>
          </ul>
        </div>

        <p>
        Le informamos que para cumplir con las finalidades previstas en este aviso de privacidad, han sido recabados
        y/o serán recabados y tratados datos personales sensibles, como aquéllos que refieren a:
        </p>

        <ul className="privacidad-lista">
          <li>Creencias religiosas</li>
          <li>Origen racial o étnico</li>
          <li>Padecimientos de salud</li>
        </ul>

        <p>
        <strong>SUPER COMPLETO SA DE CV</strong> no compartirá, sin su consentimiento previo, sus datos personales con terceros,
        nacionales o extranjeros, fuera del grupo de asociados de <strong>SUPER COMPLETO SA DE CV</strong>, salvo en los siguientes supuestos:
        </p>

        <p>
          (a)    Que la información deba compartirse con contratistas o filiales de <strong>SUPER COMPLETO SA DE CV</strong> con motivo de la relación
          contractual que mantiene con nosotros, para llevar a cabo las operaciones internas y/o cumplir con las finalidades
          de la relación contractual.
        <p>
          (b)   Se le informa que si usted no manifiesta su oposición para que sus datos personales sean transferidos, se
           entenderá que ha otorgado su consentimiento para ello.
        </p>
        <p>
        (c)    Para proteger los derechos o bienes de <strong>SUPER COMPLETO SA DE CV</strong> o de sus clientes;
        </p>
        <p>
        (d)   Que la ley o un mandato judicial así lo requieran;
        </p>
        <p>
        (e)   Que dicha transferencia esté prevista en la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.
        </p>
        <p>
        Asimismo le hacemos de su conocimiento que hemos requerido que nuestros proveedores, contratistas ó filiales
        acuerden usar sus datos personales sólo para el fin de llevar a cabo las operaciones para las cuales fueron contratados.
        </p>

        <p>
        <strong>SUPER COMPLETO SA DE CV</strong>, ha adoptado las medidas de seguridad, administrativas, técnicas y físicas, necesarias
        para proteger sus datos personales contra daño, pérdida, alteración, destrucción o el uso, acceso o tratamiento no
        autorizado. Sin embargo, <strong>SUPER COMPLETO SA DE CV</strong> no puede y por ende no garantiza que no existirá un acceso no autorizado
        a sus datos personales o que las comunicaciones estén libres de toda interrupción, error o intercepción por terceros no autorizados.
        </p>
        <p>
        El acceso a sus datos personales, en poder <strong>SUPER COMPLETO SA DE CV</strong>, se limitará a las personas que necesiten tener acceso a 
        dicha información, con el propósito de llevar a cabo las finalidades identificadas dentro del presente aviso.
        </p>

        <p>
        A partir del 01 de ENERO de 2022, Usted tendrá derecho de acceder a sus datos personales que poseemos y a los detalles del
        tratamiento de los mismos, así como a rectificarlos en caso de ser inexactos o incompletos; cancelarlos cuando considere que
        no se requieren para alguna de las finalidades señalados en el presente aviso de privacidad, estén siendo utilizados para
        finalidades no consentidas o haya finalizado la relación contractual o de servicio; revocar su consentimiento para el
        tratamiento de sus Datos Personales en cualquier momento, a fin de que se deje de hacer uso de los mismos; o bien, oponerse
        al tratamiento de los mismos para fines específicos en el presente aviso.
        </p>

        <p>
        Para hacer efectivo el ejercicio de los derechos de Acceso, Rectificación, Cancelación u Oposición de Datos Personales y
        Revocación del consentimiento, es necesario que presente una solicitud en los términos que marca la Ley en su Art. 29 a 
        nuestro Departamento de Contraloría, con domicilio en PASEO DEL TECNOLOGICO 441 en Torreón, Coahuila de Zaragoza, México,
        o bien, se comunique al teléfono +52 (871)7222 8300 o vía correo electrónico a <strong>j.varela@mapulas.com.mx </strong>el cual solicitamos confirme
        vía telefónica para garantizar su correcta recepción.
        </p>
        <p>
        La solicitud deberá contener al menos lo siguiente:
        </p>
        <ul className="privacidad-lista">
          <li>El nombre del titular, domicilio y/o correo electrónico para comunicarle la respuesta a su solicitud;</li>
          <li>Los documentos que acrediten la identidad o, en su caso, la representación legal del titular;</li>
          <li>La descripción clara y precisa de los Datos Personales respecto de los que se busca ejercer 
            lguno de los derechos antes mencionados (en el caso de rectificación se deberá indicar las modificaciones
            a realizar y aportar la documentación que sustente su petición);</li>
          <li>Cualquier otro elemento o documento que facilite la localización de los datos personales.</li>
        </ul>

        <p>
        <strong>SUPER COMPLETO SA DE CV</strong> dará respuesta a la solicitud de sus empleados, proveedores o clientes, en un plazo no
        mayor a 15 días hábiles contados a partir de la fecha en que reciba la petición correspondiente, por escrito a 
        través del domicilio o correo electrónico que sea proporcionado para tal efecto.
        </p>
        <p>
        El ejercicio por parte de los usuarios de los derechos antes mencionados deberá sujetarse a las leyes y reglamentos vigentes en México.
        </p>
        <p>
        Se hace de su conocimiento que al proporcionar cualquier tipo de información, incluyendo sus datos personales, usted expresamente:
        </p>
        <p>
        (i)    Acepta las condiciones contenidas en el presente Aviso de Privacidad;
        </p>
        <p>
        (ii)    Está de acuerdo en que la información proporcionada por usted pueda almacenarse, usarse y, en general, tratarse para los fines que se señalan, incluso para fines comerciales y de promoción;
        </p>
        <p>
        (iii)   Otorga a <strong>SUPER COMPLETO SA DE CV</strong>, autorización para obtener, compilar, almacenar, compartir,comunicar, transmitir y usar tal información de cualquier manera o forma, de conformidad con las condiciones establecidas en el presente y las leyes aplicables.
        </p>
        <p>
        <strong>IMPORTANTE: <strong>SUPER COMPLETO SA DE CV</strong>, se reserva el derecho de modificar en cualquier momento el contenido del presente Aviso de Privacidad. Cualquier cambio en el Aviso de Privacidad será publicado y podrá ser consultado en los siguientes sitios: (mural de la empresa, página de internet, periódico, etc.)</strong>
        </p>
          </p>

        <p className="privacidad-fecha">
          Una vez que se publique el Aviso de Privacidad en el Sitio entrará en vigor automáticamente. <br />
          <strong>Fecha de última actualización: 9 de abril 2025</strong>
        </p>

      </div>
    </div>
  );
};

export default PoliticaPrivacidad;
